import DeclinedOAuthPrompt from './DeclinedOAuthPrompt'

export default DeclinedOAuthPrompt
